import script from "./Activity_InfoGeneric.vue?vue&type=script&setup=true&lang=js"
export * from "./Activity_InfoGeneric.vue?vue&type=script&setup=true&lang=js"

import "./Activity_InfoGeneric.vue?vue&type=style&index=0&id=a4b1add0&lang=less&scoped=true"
import "./Activity_InfoGeneric.vue?vue&type=style&index=1&id=a4b1add0&lang=less"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-a4b1add0"]])

export default __exports__